<template>
  <main-layout>

    <div slot="left-side">
      <menubar v-if="pageType == '1'" screenIdParam="M-06-06"></menubar>
      <menubar v-else screenIdParam="M-06-24"></menubar>
    </div>

    <!--  メインページ 開始  -->
    <el-row slot="header">
      <head-title>
        <label slot="title">SSO連携情報</label>
        <lvory-but
          slot="cancel"
          class="header-clear-btn"
          @click="backPage">
          {{ $t("button.common.cancel") }}
        </lvory-but>
        <narrow-down
          slot="create"
          v-if="$authCodeCheck('010208') || $authCodeCheck('010613')"
          class="header-save-btn"
          @click="createdSsoDataInfoApi">
          {{ $t("button.common.data.create") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">

      <div style="display: flex;align-items: center;">
        <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 600;font-size: 20px;line-height: 18px;color: #525250;margin-bottom: 50px;width: 188px;">
          SSO対象
        </div>

        <div style="margin-bottom: 40px;display: flex;align-items: center;">
          <div style="margin-right: 16px;">
            <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 12px;line-height: 18px;color: #525250;">
              全ユーザーをSSO必須にする
            </div>
            <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 12px;line-height: 18px;color: #525250;">
              ※新規登録ユーザも対象となります
            </div>
          </div>
          <div style="margin-right: 56px;">
            <el-switch
              v-model="form.allAccountTargetFlag"
              :active-value="true"
              :inactive-value="false">
            </el-switch>
          </div>
        </div>
      </div>

      <div style="height: 1px;width: 800px;background-color: #D1D1CD;margin-bottom: 40px;" />

      <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 600;font-size: 20px;line-height: 18px;color: #525250;margin-bottom: 40px;width: 188px;">
        IDP設定情報
      </div>

      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="form"
        class="c-auth-form"
        label-width="188px"
        label-position="left"
        hide-required-asterisk>

        <!-- オーナと同じ設定にする -->
        <el-form-item
          v-if="showOwnerSetFlag"
          class="m-bottom-4 client-id"
          label="オーナと同じ設定にする">
          <div @click="changeOwnerSetFlag()" class="sso-switch-style">
            <el-switch
              v-model="form.ownerSetFlag"
              :active-value="true"
              :inactive-value="false"
              :disabled="true"
              >
            </el-switch>
          </div>

        </el-form-item>

        <!-- 接続先IDP種別 -->
        <el-form-item
          prop="idpType"
          class="m-bottom-4 client-id"
          label="接続先IDP種別"
          v-if="showFlag">
          <el-select
            type="slelct"
            size="samll"
            :class="form.idpType == '00' ? 'sso-el-select-00' : 'sso-el-select-01'"
            v-model="form.idpType"
            placeholder="選択してください"
          >
            <el-option
              v-for="item in form.idpList"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- プロファイル名 -->
        <el-form-item
          v-if="false"
          prop="profileName"
          class="m-bottom-4 client-id"
          label="プロファイル名">
          <el-input
            class="sso-el-input"
            maxlength="100"
            placeholder=""
            v-model="form.profileName">
          </el-input>
        </el-form-item>

        <!-- ポリシーID -->
        <el-form-item
          prop="policyId"
          class="m-bottom-4 client-id"
          label="ポリシーID"
          v-if="showFlag">
          <el-input
            class="sso-el-input"
            maxlength="20"
            placeholder=""
            v-model="form.policyId">
          </el-input>
        </el-form-item>

        <!-- IDP 識別ID -->
        <el-form-item
          prop="azureAdUUID"
          class="m-bottom-4 client-id"
          label="IDP 識別ID"
          v-if="showFlag">
          <el-input
            class="sso-el-input"
            maxlength="100"
            placeholder=""
            v-model="form.azureAdUUID">
          </el-input>
        </el-form-item>

        <!-- エンティティID -->
        <el-form-item
          v-if="false"
          prop="entityId"
          class="m-bottom-4 client-id"
          label="エンティティID">
          <el-input
            class="sso-el-input"
            maxlength="100"
            placeholder=""
            v-model="form.entityId">
          </el-input>
        </el-form-item>

        <!-- ログインページURL -->
        <el-form-item
          v-if="false"
          prop="loginUrlVal"
          class="m-bottom-4 client-id"
          label="ログインページURL">
          <el-input
            class="sso-el-input"
            maxlength="1024"
            placeholder=""
            v-model="form.loginUrlVal">
          </el-input>
        </el-form-item>

        <!-- 証明書アップロード -->
        <el-form-item
          v-if="false"
          prop="certificateFile"
          class="m-bottom-4 client-id"
          label="証明書アップロード">
          <upload-file
            @eventFile="getFile"
            @deleteFile="getFile"
           />
        </el-form-item>

        <div v-if="false" style="height: 1px;width: 800px;background-color: #D1D1CD;margin-bottom: 40px;" />

        <div v-if="false" style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 600;font-size: 20px;line-height: 18px;color: #525250;margin-bottom: 50px;">
          サービスプロバイダー(SP)情報
        </div>

        <!-- エンティティID -->
        <el-form-item
          v-if="false"
          class="m-bottom-4 client-id"
          label="エンティティID">
          <div v-if="form.entityIDText != null" style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            {{ form.entityIDText }}
          </div>
          <div v-else style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            情報が表示されます
          </div>
        </el-form-item>

        <!-- Assertion Consumer Service URL -->
        <el-form-item
          v-if="false"
          class="m-bottom-4 client-id sp-sso-form"
          label="Assertion Consumer Service URL">
          <div v-if="form.serviceUrlText != null" style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            {{ form.serviceUrlText }}
          </div>
          <div v-else style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            情報が表示されます
          </div>
        </el-form-item>

        <!-- サインオンURL -->
        <el-form-item
          v-if="false"
          class="m-bottom-4 client-id"
          label="サインオンURL">
          <div v-if="form.loginUrlText != null" style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            {{ form.loginUrlText }}
          </div>
          <div v-else style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            情報が表示されます
          </div>
        </el-form-item>

        <!-- Relay State -->
        <el-form-item
          v-if="false"
          class="m-bottom-4 client-id"
          label="Relay State">
          <div v-if="form.RelayStateText != null" style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            {{ form.RelayStateText }}
          </div>
          <div v-else style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            情報が表示されます
          </div>
        </el-form-item>

        <!-- ログアウトURL -->
        <el-form-item
          v-if="false"
          class="m-bottom-4 client-id"
          label="ログアウトURL">
          <div v-if="form.logoutUrlText != null" style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            {{ form.logoutUrlText }}
          </div>
          <div v-else style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;color: #525250;">
            情報が表示されます
          </div>
        </el-form-item>

        <!-- メタデータ -->
        <el-form-item
          v-if="false"
          class="m-bottom-4 client-id"
          label="メタデータ">
          <el-button
            class="down-sso-xml"
            :disabled="form.xmlDownloadUrl == null || form.xmlDownloadUrl == ''"
            @click="downLoadXml">
            ダウンロード
          </el-button>
        </el-form-item>

      </el-form>
      <dialog-index
        :centerDialogVisibleParam.sync="isDialogShowFlag"
        :msgParam="msg"
        @on-isPassParam="pageConfirm"
        @on-cancel="onCancel"/>

      <loading-dialog :dialogVisible="showLoading" />


    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import HeadTitle from "@/components/common/head/head"
import MainLayout from "@/layout/NewDesignLayout"
import NarrowDown from "@/components/common/generalButton/NarrowDown"
import errorCodeMsg from "@/utils/error-code-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import SystemManageApi from "@/api/SystemManageApi"
import UploadFile from "@/components/common/sp-smart-upload/uploadFile"
import DialogIndex from "@/components/common/el-dialog-prompt-owner";

export default {
  name: "SsoDetail",
  components: {
    Menubar: Menubar,
    LvoryBut: LvoryBut,
    HeadTitle: HeadTitle,
    MainLayout: MainLayout,
    NarrowDown: NarrowDown,
    UploadFile: UploadFile,
    LoadingDialog: LoadingDialog,
    DialogIndex: DialogIndex
  },
  data() {
    const checkAzureAdUUID = (rules, value, callback) => {
      if(this.form.idpType == '01') {
        if (value == '' ||  value == null || value == undefined) {
          callback(new Error(
            this.$t("message.common.validation.required", {
              field: 'IDP 識別ID'
            })
          ))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const checkAzureAdPolicyID =(rules, value, callback) => {
      if(this.form.idpType == '00') {
          callback()
      } else {
        if (value == '' ||  value == null || value == undefined) {
          callback(new Error(
              this.$t("message.common.validation.required", {
                field: 'ポリシーID'
              })
            ))
        }else{
          callback()
        }
      }
    }
    return {
      showOwnerSetFlag: false,
      showFlag: false,
      showLoading: false,
      rules: {
        profileName: [
          {
            max: 100,
            trigger: 'blur',
            message: this.$t('message.common.validation.max', {
              field: 'プロファイル名',
              length: 100
            })
          }
        ],
        azureAdUUID: [
          {
            validator: checkAzureAdUUID,
            trigger: 'blur',
          },
          {
            max: 100,
            trigger: 'blur',
            message: this.$t('message.common.validation.max', {
              field: 'IDP 識別ID',
              length: 100
            })
          }
        ],
        entityId: [
          {
            max: 100,
            trigger: 'blur',
            message: this.$t('message.common.validation.max', {
              field: 'エンティティID',
              length: 100
            })
          }
        ],
        loginUrlVal: [
          {
            pattern: /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$/g,
            trigger: 'blur',
            message: this.$t('message.common.validation.type', { field: 'ログインページURL', type: 'URL' })
          },
          {
            max: 1024,
            trigger: 'blur',
            message: this.$t('message.common.validation.max', {
              field: 'ログインページURL',
              length: 1024
            })
          }
        ],
        policyId: [
          {
            validator: checkAzureAdPolicyID,
            trigger: 'blur',
          },
          {
            pattern: /^[ -~｡-ﾟ]+$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: 'ポリシーID',
              type: '半角'
            })
          }
        ]
      },
      tenantId: null,
      pageType: null,
      orgId: null,
      form: {
        allAccountTargetFlag: false,
        idpList: [],
        idpType: null,
        profileName: null,
        azureAdUUID: null,
        entityId: null,
        loginUrlVal: null,
        logoutUrlVal: null,
        entityIDText: null,
        serviceUrlText: null,
        loginUrlText: null,
        RelayStateText: null,
        logoutUrlText: null,
        xmlDownloadUrl: null,
        policyId: null,
        certificateFile: null,
        ownerSetFlag: false,
        ownerSSOToTenantFlag: false
      },
      initOwnerSetFlag: false,
      isDialogShowFlag: false,
      msg:"SSO設定が変更されます\nよろしいですか？"
    }
  },
  created() {
    this.dataInfo()
    if (this.pageType == '1') {
      let breadcrumb = [
        {
          path: "/",
          title: "label.router.home",
        },
        {
          path: "/system/setting/various",
          title: "label.router.set",
        },
        {
          path: "",
          title: "label.router.comprehensive",
        },
        {
          path: "/system/owners/search",
          title: "label.router.owner",
        },
        {
          path: "",
          title: "label.router.sso",
        }
      ]
      this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    } else {
      var breadcrumb = [
        {
          path: "/",
          title: "label.router.home",
        },
        {
          path: "/system/setting/various",
          title: "label.router.set",
        },
        {
          path: "",
          title: "label.router.comprehensive",
        },
        {
          path: "/system/tenants/search",
          title: "label.router.Thetenant",
        },
        {
          path: "",
          title: "label.router.tenantDetail",
        },
        {
          path: "",
          title: "label.router.sso",
        },
      ]
      this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    }
  },
  mounted() {
    this.getSsoInfoApi()
  },
  watch: {
    "form.ownerSetFlag"(val){
      if (this.$IsTenantManager() || this.$IsSBManager()) {
        if (val) {
          this.showFlag = false
        } else {
          this.showFlag = true
          if (this.pageType == 2) {
            if (this.$IsTenantManager()) {
              if (this.initOwnerSetFlag) {
                // ownerのsso
                this.showFlag = false
              } else {
                // tenantのsso
                if (!this.$IsNullOrEmpty(this.form.policyId) || !this.$IsNullOrEmpty(this.form.azureAdUUID)) {
                  this.showFlag = true
                } else {
                  this.showFlag = false
                }
              }
            } else {
              if (this.initOwnerSetFlag) {
                // ownerのsso
                this.form.idpType = "00"
                this.form.azureAdUUID = null
                this.form.policyId = null
              } else {
                // tenantのsso
                if (!this.$IsNullOrEmpty(this.form.policyId) || !this.$IsNullOrEmpty(this.form.azureAdUUID)) {
                  this.showFlag = true
                } else {
                  this.showFlag = false
                }

                if (this.$IsSBManager()) {
                  this.showFlag = true
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {

    dataInfo () {
      this.pageType = this.$route.query.pageType
      if (this.pageType == '1') {
        this.orgId = this.$route.query.ownerId
        this.ownerDetail = JSON.parse(this.$route.query.ownerDetail)

      } else {
        this.orgId = this.$route.query.tenantId
      }
    },

    getSsoInfoApi() {
      this.showLoading = true
      SystemManageApi.getSystemOrgSso(this.orgId)
      .then(({data}) => {
        this.clearData()
        if (data.body != null && data.body != undefined && data.body != "") {
          this.form.allAccountTargetFlag = data.body.allAccountTargetFlag
          this.form.idpList = data.body.idpList
          this.form.idpType = data.body.idpType
          this.form.profileName = data.body.profileName
          this.form.azureAdUUID = data.body.azureAdUUID
          this.form.entityId = data.body.entityId
          this.form.loginUrlVal = data.body.loginUrlVal
          this.form.logoutUrlVal = data.body.logoutUrlVal
          this.form.entityIDText = data.body.entityIDText
          this.form.serviceUrlText = data.body.serviceUrlText
          this.form.loginUrlText = data.body.loginUrlText
          this.form.RelayStateText = data.body.RelayStateText
          this.form.logoutUrlText = data.body.logoutUrlText
          this.form.policyId = data.body.policyId
          this.form.xmlDownloadUrl = data.body.xmlDownloadUrl
          this.form.ownerSSOToTenantFlag = data.body.ownerSSOToTenantFlag

          this.initOwnerSetFlag = data.body.ownerSetFlag

          // テナント情報から
          // テナントのSSO情報の場合、下記処理
          this.showFlag = true
          if (this.pageType == 2) {
            // ①組織SSOログイン情報取得API．オーナーSSO設定をテナントに引継ぐフラグ＝Trueの場合
            if (this.form.ownerSSOToTenantFlag) {
              // ①-1組織SSOログイン情報取得API．オーナと同じ設定フラグ=Trueの場合、テナント非表示
              if (data.body.ownerSetFlag) {
                this.showFlag = false
              } else {
                // ①-2組織SSOログイン情報取得API．オーナと同じ設定フラグ=falseの場合 かつテナントのsso情報設定しない場合かつ、テナント管理者登録する場合、非表示
                // ①-3組織SSOログイン情報取得API．オーナと同じ設定フラグ=falseの場合 かつテナントのsso情報設定する場合かつ、テナント管理者登録する場合、表示
                if (this.$IsTenantManager()) {
                  if (!this.$IsNullOrEmpty(this.form.policyId) || !this.$IsNullOrEmpty(this.form.azureAdUUID)) {
                    this.showFlag = true
                  } else {
                    this.showFlag = false
                  }
                }
              }
            } else {
              this.showFlag = true
            }
          } else {
            this.showFlag = true
          }

          this.form.ownerSetFlag = data.body.ownerSetFlag

          this.showOwnerSetFlag = false
          if (this.pageType == 2) {
            if (this.form.ownerSSOToTenantFlag) {
              this.showOwnerSetFlag = true
            }
          }
        }
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .finally(() => {
        this.showLoading = false
      })
    },

    getFile (array) {
      if (array.length === 0) {
        this.form.certificateFile = null
      } else {
        this.form.certificateFile = array[0].raw
      }
    },

    createdSsoDataInfoApi() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {

          let specialCheckFlag = false
          if (!this.$IsNullOrEmpty(this.form.azureAdUUID)) {
            if (this.$checkSpecialKeyWord(this.form.azureAdUUID)) {
              specialCheckFlag = true
              this.$messageIotError(this.$t('message.common.validation.inputSpecialKeyword',{
                  field: "IDP 識別ID",
                  keyWord: "<、>、\"、'"
              }))
            }
          }
          if (!specialCheckFlag) {
            this.createdSsoInfo()
          }
        }
      })
    },

    createdSsoInfo() {
      let request = {
        certificateFile: this.form.certificateFile,
        allAccountTargetFlag: this.form.allAccountTargetFlag,
        idpType: this.showFlag ? this.form.idpType : null,
        profileName: this.form.profileName,
        azureAdUUID: this.showFlag ? this.form.azureAdUUID : null,
        entityId: this.form.entityId,
        loginUrlVal: this.form.loginUrlVal,
        logoutUrlVal: this.form.logoutUrlVal,
        policyId: this.showFlag ? this.form.policyId : null,
        ownerSetFlag: this.form.ownerSetFlag
      }
      this.doneCreatedSsoInfo(request)
    },

    clearData () {
      this.form.allAccountTargetFlag = null
      this.form.idpList = null
      this.form.idpType = null
      this.form.profileName = null
      this.form.azureAdUUID = null
      this.form.entityId = null
      this.form.loginUrlVal = null
      this.form.logoutUrlVal = null
      this.form.entityIDText = null
      this.form.serviceUrlText = null
      this.form.loginUrlText = null
      this.form.RelayStateText = null
      this.form.logoutUrlText = null
      this.form.xmlDownloadUrl = null
      this.form.certificateFile = null
      this.form.policyId = null
    },

    doneCreatedSsoInfo(req) {
      this.showLoading = true
      SystemManageApi.putSystemOrgSso(this.orgId, req)
        .then(({data}) => {

          if (data.statusCode == "Failure.TenantInheritOwner") {
            this.$messageIotError(this.$t("message.common.error.ERR_TENANT_INHERIT_OWNER_MSG"))
          }

          if (data.statusCode == "Success") {
            this.$messageIotSuccess(this.$t("message.common.save"))
          }
          this.getSsoInfoApi()
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },

    downLoadXml () {
      window.location.href = this.form.xmlDownloadUrl
    },

    backPage () {
      if (this.pageType == '1') {
        this.$router.push({
          name: "system-owner-setting-edit",
          query: {
            orgId: this.orgId,
            ownerDetail: JSON.stringify(this.ownerDetail)
          }
        })
      } else {
        this.$router.push({
          name: "system-tenant-detail",
          params: {
            tenantId: this.orgId
          }
        })
      }

    },
    changeOwnerSetFlag(){
      this.isDialogShowFlag = true
    },
    pageConfirm(){
      this.isDialogShowFlag = false
      this.form.ownerSetFlag = !this.form.ownerSetFlag;
    },
    onCancel(){
      this.isDialogShowFlag = false
    },

  }
}
</script>

<style scoped lang="scss">
.header-save-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.header-clear-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.c-auth-form::v-deep {
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-input__inner {
    height: 44px !important;
  }
  .el-form-item__label {
    font-size: 16px;
  }
}
.c-auth-save-btn {
  margin-left: 188px;
  margin-top: 60px;
}
.domain {
  color: #525250;
  font-size: 14px;
}
.client-id::v-deep {
  .el-input .el-input__inner {
    width: 528px;
  }
}
::v-deep .new-input-shadow .el-input__inner {
  background: #F7F7F2 !important;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA !important;
  border-radius: 8px;
}
::v-deep .new-input-shadow .el-textarea__inner {
  background: #F7F7F2 !important;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA !important;
  border-radius: 8px;
}
.iot-popover-image-size {
  position: relative;
  cursor: pointer;
  top: -170px;
  left: 500px;
  height: 18px;
}
::v-deep .last-input-sp .el-form-item__content .el-form-item__error {
  margin-top: -40px;
}
::v-deep .sso-el-select-00 {
  height: 32px !important;
  width: 200px;
  line-height: 32px !important;
}
::v-deep .sso-el-select-01 {
  height: 32px !important;
  width: 260px;
  line-height: 32px !important;
}
::v-deep .sso-el-select-00 .el-input {
  height: 32px;
  .el-input__inner {
    height: 32px !important;
  }
}
::v-deep .sso-el-select-01 .el-input {
  height: 32px;
  .el-input__inner {
    height: 32px !important;
  }
}
::v-deep .sso-el-input {
  height: 34px !important;
  width: 528px;
  line-height: 34px !important;
  .el-input__inner {
    height: 34px !important;
    box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA !important;
  }
}
::v-deep .sp-sso-form .el-form-item__label {
  line-height: 24px !important;
}
.down-sso-xml {
  width: 122px;
  height: 32px;
  background: #F2F2ED;
  box-shadow: -4px -4px 5px #FFFFFF, 4px 4px 8px #E6E6D8;
  border-radius: 8px;
  border: none;
  padding: 0;
  color: #525250;
  font-family: 'Hiragino Kaku Gothic Pro';
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
}
.down-sso-xml:hover {
  opacity: 0.8;
  background: #F2F2ED;
  color: #525250;
  font-family: 'Hiragino Kaku Gothic Pro';
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
}
.sso-switch-style{
  ::v-deep.el-switch.is-disabled{
    opacity: 1 !important;
  }
  ::v-deep.el-switch.is-disabled .el-switch__core{
    cursor: pointer !important;
  }
}
</style>
